import { render, staticRenderFns } from "./ExhibitorInboxView.vue?vue&type=template&id=a93ed4f8&scoped=true"
import script from "./ExhibitorInboxView.vue?vue&type=script&lang=js"
export * from "./ExhibitorInboxView.vue?vue&type=script&lang=js"
import style0 from "./ExhibitorInboxView.vue?vue&type=style&index=0&id=a93ed4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93ed4f8",
  null
  
)

export default component.exports